module.exports = function getResource(label, vars = []) {
    const resources = {
        signIn: 'Sign In',
        sigInToSeeItems: 'Sign in to see items you may have added previously.',
        seeSamplesRewardsPromotions: 'See samples, rewards, and promos in',
        basket: 'basket',
        dcTotal: 'Get It Shipped ',
        basketTotal: 'Subtotal ',
        reserveTotal: 'Reserve & Pick Up ',
        bopisTotal: 'Buy Online & Pick Up ',
        checkout: 'View Basket & Checkout',
        emptyBasket: 'Your basket is empty.',
        itemsInBasket: `${vars[0]} item${vars[1]} in basket`,
        itemsAddedToBasket: `${vars[0]} item${vars[1]} added to basket`,
        itemCount: `${vars[0]} item${vars[1]}`,
        or: 'or',
        shopNewArrivals: 'Shop New Arrivals',
        viewAll: 'View all',
        freeShipping: 'Free Shipping',
        createAccount: 'Create Account',
        basketHeader: `Get It Shipped (${vars[0]})`,
        reserveHeader: `Reserve & Pick Up (${vars[0]})`,
        bopisHeader: `Buy Online & Pick Up (${vars[0]})`,
        sameDayDelivery: 'Same-Day Delivery',
        standardDelivery: 'Standard',
        getBackToYourBasket: 'Get Back to Your Basket'
    };

    return resources[label];
};
